import { Component, OnInit } from '@angular/core';
import { TranslationService } from './../../services/translation.service';

@Component({
  selector: 'app-pre-footer',
  templateUrl: './pre-footer.component.html',
  styleUrls: ['./pre-footer.component.scss'],
  standalone: false,
})
export class PreFooterComponent {
  translations?: any;

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.translationService.getTranslations().subscribe((translations) => {
      this.translations = translations;
    });
  }
}
